module.exports = __webpack_public_path__ + "prod/1.42.2/img/ios-icon.1433a349.svg";